module.exports = __webpack_public_path__ + "img/globe.4667aca2.gif";